<template>
  <el-tag
    v-if="ready"
    :hit="true"
    type="success"
    size="small"
  >
    <el-popover
      placement="top-start"
      trigger="hover"
      popper-class="auto-width"
      @show="shown = true"
      @hide="shown = false"
    >
      <div :class="{ 'preview-box': !isIcon }">
        <template v-if="shown">
          <video
            v-if="isVideo"
            :key="video"
            controls
            autoplay
            muted
            class="video-preview"
          >
            <source :src="previewUrl" type="video/mp4" />
          </video>
          <div v-else-if="isIcon" class="push-preview">
            <div class="push-preview__icon">
              <img :src="previewUrl" alt="Icon" />
            </div>
            <div class="push-preview__body">
              <div class="push-preview__title">
                {{ title }}
              </div>
              <div class="push-preview__description">
                {{ description }}
              </div>
              <div class="push-preview__domain">
                {{ domain }}
              </div>
            </div>
          </div>
          <img v-else :src="previewUrl" class="image-preview" />
        </template>
      </div>
      <template #reference>
        <a :href="url" target="_blank" title="Click to download for review">
          <el-icon>
            <ViewElementIcon />
          </el-icon>
        </a>
      </template>
    </el-popover>
  </el-tag>
  <el-tag v-else :key="componentKey" :hit="true" type="info" size="small">
    Pending
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'
import appEnv from '@/support/env'

export default defineComponent({
  name: 'CreativeAssetProcessingState',
  props: {
    processed: {
      type: Boolean,
      default: false
    },
    creature: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const userStore = useUserStore()
    const buildUrl = () => {
      const domain = userStore.staff ? appEnv.MAIN_APP_ADMIN : appEnv.ASSETS_API
      return `${domain}/creatives/${props.creature.id}/preview`
    }

    const isVideo = computed(() => {
      return (
        props.creature.video_preview.length > 0 ||
        props.creature.image_preview.endsWith('.mp4')
      )
    })

    const isIcon = computed(() => {
      return props.creature.icon_preview.length > 0
    })

    const previewUrl = computed(() => {
      let imagePath = props.creature.video_preview
      if (imagePath === '') {
        imagePath = props.creature.image_preview
      }
      if (imagePath === '') {
        imagePath = props.creature.icon_preview
      }
      if (
        appEnv.ENV === 'development' &&
        imagePath &&
        !/^https?:\/\//.test(imagePath)
      ) {
        imagePath = `${appEnv.MAIN_APP_BASE}/${imagePath}`
      }

      return imagePath
    })

    const domain = computed(() => {
      const regex = /(?:[\w-]+\.)+[\w-]+/
      const match = regex.exec(props.creature.link_url)
      if (match === null) {
        return ''
      }

      return match[0]
    })

    const ready = computed(() => props.processed)
    const url = computed(() => (props.processed ? buildUrl() : '#'))
    const shown = ref(false)

    return {
      ready: ready,
      url: url,
      shown: shown,
      previewUrl: previewUrl,
      isVideo: isVideo,
      isIcon: isIcon,
      title: props.creature.title,
      description: props.creature.description,
      domain: domain
    }
  }
})
</script>
<style lang="scss" scoped>
.preview-box {
  width: 400px;
  height: 300px;
}
.video-preview,
.image-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.el-tag {
  border: none !important;
}
.push-preview {
  width: 330px;
  .push-preview__icon {
    float: left;
    width: 100px;
    margin-right: 10px;
    img {
      max-width: 100%;
    }
  }
  .push-preview__body {
    position: relative;
    min-height: 100px;
    .push-preview__title {
      font-weight: bold;
      margin-bottom: 5px;
    }
    .push-preview__domain {
      color: #409eff;
      position: absolute;
      left: 110px;
      bottom: 0;
      font-size: 11px;
    }
  }
}
</style>
